export default {
  computed: {
    datePickerFormat() {
      return 'DD.MM.YYYY';
    },
    datePickerBindingFormat() {
      return 'DD.MM.YYYY';
    }
  }
};
